import * as React from "react";
import { Button, ButtonProps, styled } from "@mui/material";
import clsx from "clsx";
import { useTranslate } from "../../hooks/useTranslate";
import { PatientColorMap } from "../../layout/patientColorMap";
import { onRtl } from "fe-web-components/rtl/rtlStyles";
import { ReactComponent as BackIconSvg } from "../../assets/back.svg";

//region [[ Styles ]]

const CommonBackButtonView = styled(Button)({
  // Make sure we always win specificity
  "&.common-back-button, &.common-back-button:focus, &.common-back-button:hover, &.common-back-button:focus": {
    background: "transparent",
    border: `1px solid ${PatientColorMap.PrimaryLight}`,
    padding: "7px 8px",
    color: PatientColorMap.Default,
    display: "flex",
    flexFlow: "row",
    justifyContent: "flex-start",
    borderRadius: "68px",
    "& span": {
      textTransform: "none",
    },
    "&.forward span": {
      justifyContent: "flex-end",
      flexFlow: "row-reverse",
    },
  },
});

const BackText = styled("span")({
  fontSize: "10px",
  lineHeight: "10px",
  fontWeight: 500,
  flex: 1,
});

const BackIcon = styled(BackIconSvg)({
  fill: PatientColorMap.Default,
  ...onRtl({
    transform: "rotateY(-180deg)",
  }),
  ".forward &": {
    transform: "rotateY(-180deg)",
    ...onRtl({
      transform: "rotateY(0)",
    }),
  },
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface CommonBackButtonProps extends ButtonProps {
  className: string;
  forward?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const CommonBackButton = ({ ...props }: CommonBackButtonProps) => {
  const { translate } = useTranslate();
  return (
    <CommonBackButtonView
      {...props}
      className={clsx(
        props.className,
        "common-back-button",
        props.forward ? "forward" : null,
      )}
    >
      <BackIcon />
      <BackText>{translate(!!props.forward ? "FORWARD" : "BACK")}</BackText>
    </CommonBackButtonView>
  );
};
